import { render, staticRenderFns } from "./formsnew.vue?vue&type=template&id=33738399&scoped=true"
import script from "./formsnew.vue?vue&type=script&lang=js"
export * from "./formsnew.vue?vue&type=script&lang=js"
import style0 from "./formsnew.vue?vue&type=style&index=0&id=33738399&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33738399",
  null
  
)

export default component.exports